
function initFreeShipping() {
  const FREE_SHIP = 5000;

  async function updateProgress() {
    try {
      const cart      = await fetch('/cart.js').then(r => r.json());
      const total     = cart.total_price; 
      const giftTh    = 3000;
      const freeTh    = 5000;
  
      const remainingGift = giftTh - total;        
      const remainingFree = freeTh - total;           
  
      const textEl = document.getElementById('shipping-progress-text');
      const fillEl = document.getElementById('progress-bar-fill');
  
      if (remainingGift > 0) {
        const amt = (remainingGift/100).toFixed(2).replace('.', ',');
        textEl.textContent = `Noch ${amt} € bis zu deinem Geschenk!`;
  
      } else if (remainingFree > 0) {
        const amt = (remainingFree/100).toFixed(2).replace('.', ',');
        textEl.textContent = `Dein Geschenk ist dir sicher. Noch ${amt} € bis zum kostenlosen Versand!`;
  
      } else {
        textEl.textContent = 'Yay! Du bekommst ein Geschenk und hast kostenlosen Versand!';
      }
  
      const pct = Math.min(100, (total / freeTh) * 100);
      fillEl.style.width = `${pct}%`;
  
    } catch (e) {
      console.error('Free-shipping update failed', e);
    }
  }

  updateProgress();

  document.body.addEventListener('cart:updated', updateProgress);
  document.body.addEventListener('eurus:cart:items-changed', updateProgress);

  const drawerRoot = document.getElementById('CartDrawer') || document.getElementById('update-cart');
  if (drawerRoot) {
    new MutationObserver(updateProgress)
      .observe(drawerRoot, { childList: true, subtree: true });
  }

  setInterval(updateProgress, 2000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFreeShipping);
} else {
  initFreeShipping();
}




